export default "__VITE_ASSET__CcIqbGpK__"